module.exports = __webpack_public_path__ + "img/undraw_road_sign_mfpo.75519109.svg";